<template>
    <content-layout>
        <template slot="header">
            <div class="breadcrumb" v-if="categoryNode">
                <span class="crumb"><router-link :to="{ name: 'home' }">Sākums</router-link></span>
                <span class="crumb" v-for="p in categoryNode.path">
                    <router-link :to="{ name: 'category', params: { categoryNodeId: p.id } }" :key="p.id">{{p.category.title}}</router-link>
                </span>
                <span class="crumb">{{ categoryTitle }}</span>
            </div>
            <h1 class="category-title" v-if="categoryTitle">{{ categoryTitle }}</h1>
            <h4 class="category-subtitle" v-if="categoryDescription">{{ categoryDescription }}</h4>
        </template>

        <div class="file-filter-container" v-if="categoryNode">
            <div class="row column">
                <router-link v-if="categoryTitle === 'Noderīgas saites'" class="button clear float-right"
                             :to="{ name: 'upload', params: { categories, type: 'link' } }">+ Pievienot<span class="show-for-medium"> šajā sadaļā</span></router-link>
                <router-link v-else="" class="button clear float-right"
                             :to="{ name: 'upload', params: { categories, type: 'file' } }">+ Augšuplādēt<span class="show-for-medium"> šajā sadaļā</span></router-link>
                <material-filter :current.sync="sort"></material-filter>
            </div>
        </div>

        <div class="file-list-container">
            <div class="row small-up-2 medium-up-3 large-up-5">
                <spinner v-if="loading === true" class="spinner"></spinner>
                <template v-else="">
                    <div class="column" v-for="material in materials" :key="material.id">
                        <material-item :material="material" v-on:update:material="updateMaterial($event)"></material-item>
                    </div>
                </template>
            </div>
        </div>

        <div class="pagination-container">
            <pagination :current.sync="page" :total="totalPages"></pagination>
        </div>
    </content-layout>
</template>

<script>
    import ContentLayout from '../layouts/ContentLayout'
    import MaterialItem from '../components/MaterialItem'
    import MaterialFilter from '../components/MaterialFilter'
    import categories from '../api/categories'
    import Materials from '../api/materials'
    import Pagination from '../components/common/Pagination'

    export default {

        created() {
            this.getCategory();
        },

        props: ['categoryNodeId'],

        data() {
            return {
                categoryNode: null,
                categoryTitle: '',
                categoryDescription: '',
                materials: [],
                sort: 'created_at',
                totalPages: 1,
                page: 1,
                loading: false
            }
        },

        methods: {
            /**
             * Get current category node.
             */
            getCategory() {
                //TODO find in pre-loaded category tree (in vuex store)...
                categories.find(this.categoryNodeId)
                    .then(response => {
                        this.categoryNode = response.data;
                        this.categoryTitle = this.categoryNode.category.title;
                        this.categoryDescription = this.categoryNode.category.description;

                })
            },

            /**
             * Get materials for current category node considering all parent categories.
             * Set total page count and current page index.
             */
            getMaterials() {
                this.loading = true
                Materials.get({ categories: this.categories.map(c => c.id), page: this.page, sort: this.sort })
                    .then(response => {
                        this.setMaterials(response.data)
                        this.loading = false
                    });
            },

            /**
             * Set the materials and pagination data from API data.
             * @param {Object} data
             * @param {Object} links
             * @param {Object} meta
             */
            setMaterials({ data, links, meta }) {
                this.materials = data;
                this.totalPages = meta ? meta.last_page : 1;
                this.page = meta ? meta.current_page : 1;
            },

            /**
             * Find the material in  the materials collection and update it.
             * @param {Object} material
             */
            updateMaterial(material) {
                console.log('updating material', material);

                // Find the material within existing collection and update it
                this.materials.forEach((m, i, arr) => {
                    if (m.id === material.id)  arr.splice(i, 1, material);
                });
            },

            /**
             * Reset component data
             */
            reset() {
                Object.assign(this.$data, this.$options.data.apply(this));
            }
        },

        computed: {
            /**
             * Get all parent category ids. Including the current category.
             * @returns {Array}
             */
            categories: function () {
                if (this.categoryNode === null) return [];

                const c = this.categoryNode.path.map(categoryNode => categoryNode.category);
                return [this.categoryNode.category].concat(c);
            },
        },

        watch: {
            categoryNodeId: function (val, oldVal) {
                console.log('categoryNodeId has changed', val, oldVal);

                if (typeof val === 'undefined' || val === null) {
                    this.reset();
                } else if (val !== oldVal) {
                    this.getCategory();
                }
            },

            categoryNode: function(val, oldVal) {
                console.log('categoryNode has changed', val, oldVal);

                if (val === null) {
                    this.materials = [];
                    this.totalPages = 1;
                    this.page = 1;
                } else if (oldVal === null || val.id !== oldVal.id) {
                    this.getMaterials();
                }
            },

            sort: function (val, oldVal) {
                console.log('sort has changed', val, oldVal);
                this.getMaterials();
            },

            page: function (val, oldVal) {
                console.log('page has changed', val, oldVal);
                this.getMaterials()
            }
        },

        components: {MaterialItem, MaterialFilter, ContentLayout, Pagination}
    }
</script>

<style lang="scss" scoped>
    @import "../../sass/settings";
    @import "../../sass/mixins";

    .category-header {
        padding-bottom: 35px;
    }

    //TODO duplicate
    .file-filter-container {
        background-color: white;

        a {
            padding: 19px 0.55556em;
            font-weight: 700;
            font-size: 18px;
            line-height: 1;
            margin-bottom: 0;
        }
    }

    //TODO duplicate
    .file-list-container {
        padding-bottom: 1.875rem;
    }

    .pagination-container {
        text-align: center;
    }

    .breadcrumb {
        color: white;
        font-size: px-em(12px);
    }

    .category-title {

    }

    .category-subtitle {
        color: white;
        margin-top: -0.8em;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/views/CategoryMaterials.vue